// Scrolly-Viewer — Route `/s/:slug` (legacy short-link, slug treated as
// publicKey). Phase-4 STOPP 4.A.8: page-body extracted into
// `ScrollyViewerPage` shared with `/scrolly/:publicKey`,
// `/:orgSlug/:scrollySlug`, and `/scrollytelling/:orgSlug/:scrollySlug`.
//
// This page is the only viewer-route that opts into the mock-fallback
// (`SCROLLYS_BY_SLUG[slug]`) — feed-mocks are slug-keyed for dev hosts
// without backend coverage. Other Phase-4 routes leave that fallback off.

import { usePageContext } from "../../../src/hooks/usePageContext";
import { ScrollyViewerPage } from "../../../src/components/viewer/ScrollyViewerPage";
import type { ResolvedScrollyPageData } from "../../../src/lib/api/resolved-scrolly-page-data";

export default function Page() {
  const pageContext = usePageContext();
  const slug = pageContext.routeParams?.slug ?? "";
  const pageData = pageContext.data as ResolvedScrollyPageData | undefined;
  return (
    <ScrollyViewerPage
      pageContext={pageContext}
      pageData={pageData}
      urlKey={slug}
      mockFallbackKey={slug}
      notFoundUrlPrefix="/s"
    />
  );
}
